import { legislativeStatusCategory, legislativeStatusOutcome, } from '@govinity/shared-config';
import { z } from 'zod';
export { legislativeStatusCategory, legislativeStatusOutcome };
/**
 * Field shape shared by the create/update payloads and by callers that need the
 * raw object without the terminal-outcome refinement — notably the support MCP
 * tool, which derives its input schema from `.partial().shape`.
 */
export const legislativeStatusBaseSchema = z.object({
    name: z.string().min(1, 'Name is required').max(255),
    code: z.string().min(1, 'Code is required').max(255),
    description: z
        .string()
        .min(1, 'Description is required')
        .nullable()
        .describe('Send null rather than omitting when the status has no description.'),
    orderById: z
        .number()
        .min(1, 'Order by is required')
        .optional()
        .describe('Position in status lists. Defaults to the end of the list when omitted.'),
    isActive: z.boolean(),
    category: z.enum(legislativeStatusCategory),
    outcome: z
        .enum(legislativeStatusOutcome)
        .nullish()
        .describe('Required when isTerminal is true; forced to null when isTerminal is false.'),
    isTerminal: z
        .boolean()
        .describe('True exits the item from deliberation into `outcome`; false keeps it deliberating.'),
});
const legislativeStatusValidatedSchema = legislativeStatusBaseSchema.refine((data) => !data.isTerminal || (data.outcome !== null && data.outcome !== undefined), {
    message: 'Outcome is required for terminal statuses',
    path: ['outcome'],
});
/** Form schema without transforms (for react-hook-form). */
export const legislativeStatusFormSchema = legislativeStatusValidatedSchema;
export const legislativeStatusCreateSchema = legislativeStatusValidatedSchema.transform((data) => ({
    ...data,
    outcome: data.isTerminal ? data.outcome : null,
}));
export const legislativeStatusUpdateSchema = legislativeStatusCreateSchema;
